/* Translated: yes */
export default {
  computed: {
    timelineSteps() {
      let steps = [];
      const $this = this;

      const rentals = (
        this.$store.state.cart
        .rentals
        .length
      );

      let confirmedRentals = (
        this.$store.state.cart
        .rentals.filter(a => a.guideCompleted)
        .length
      );

      this.$store.state.cart.rentals.forEach((person, index) => {
        const no = index + 1;
        const skiier = this.$i18n.t('general.skier');
        const p = {
          title: (person.name || `${skiier} ${no}`),
          complete: 0,
          url: { name: 'ski rental person', params: { person: index } },
          clickable: person.guideCompleted,
        };

        if (person.guideFullyCompleted) {
          p.complete = 2;
        }

        if (parseInt($this.$route.params.person, 10) === index) {
          p.complete = 1;
        }

        if ($this.currentIndex === index && person.products.length) {
          p.complete = 1;
        }

        steps.push(p);
      });

      if (steps.length > 6) {
        steps = [{
          title: this.$i18n.t('general.cta.book'),
          complete: 2,
          url: { name: 'ski rental overview' },
          clickable: confirmedRentals,
        }];

        if (parseInt($this.$route.params.person, 10) >= 0) {
          steps[0].complete = 1;
          confirmedRentals = -1;
        }
      }

      steps.push({
        title: this.$i18n.t('general.overview'),
        complete: (confirmedRentals === rentals ? 1 : 0),
        url: { name: 'ski rental overview' },
        clickable: confirmedRentals,
      });

      return steps;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/rentalTimelineSteps.js